var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error.statusCode === 403)?_c('ForbiddenPage'):_c('NotFoundPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }